import React, { Component } from 'react';
import MdPerson from 'react-icons/lib/md/person';
import { connect } from 'react-redux';
import MdClose from 'react-icons/lib/md/close';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './styles.css';
import { switchApplyPopup, nextApplyStep, prevApplyStep, updateDetails, sendDetails, removeTeammatesField, checkEmails, checkTeam } from '../../actions';
import { RegisterStep, RaisedButton, Section, Teammates, Accounts, NameInput } from '../../components';
// inputChangeText

class ModalApply extends Component {

  constructor(props){
    super(props);
    this.state = {
      details: this.props.details,
      teammatesValid: false,
      multivalue: [],
      displayError: '',
    }
  }

  componentDidMount() {
    // this.inputChangeText = debounce(this.inputChangeText, 500);
  }

  componentWillReceiveProps(props){
    this.setState({details: props.details});
  }
  renderCounter(){
    let subStep = this.props.currentSubstep;
    let allSubsteps = this.props.steps[this.props.currentStep - 1].substeps.length;
    return `${subStep}/${allSubsteps}`;
  }
  renderStepTitle(){
    let subStep = this.props.currentSubstep;
    let title = this.props.steps[this.props.currentStep - 1].substeps[subStep - 1].title;
    if(this.props.steps[this.props.currentStep - 1].substeps[subStep - 1].field === 'toc'){
      return (
        <span>Do you agree to our <a target="_blank" href="/adidas-terms_conditions-apply.pdf">Terms & Conditions</a>? *</span>
      );
    }
    return title;
  }

  renderDescription(){
    let subStep = this.props.currentSubstep;
    let desc = this.props.steps[this.props.currentStep - 1].substeps[subStep - 1].description;
    return desc;
  }

  handleChange(e){
    let subStep = this.props.currentSubstep;
    let SubStepDetails = this.props.steps[this.props.currentStep - 1].substeps[subStep - 1];
    let newDetails = Object.assign({}, this.state.details);
    newDetails[e.name] = e.value;
    if(SubStepDetails.type === 'multiselect'){
      newDetails[SubStepDetails.field] = e;
      this.setState({details: newDetails}, () => {
        this.props.dispatch(updateDetails(SubStepDetails.field, e));
      })
    }else{
      // console.log(SubStepDetails.validation.items.indexOf(SubStepDetails.options.indexOf(newDetails[e.name])) !== -1);
      console.log(SubStepDetails.validation);
      if(SubStepDetails.validation && SubStepDetails.validation.type === 'block'){
        this.updateRegistartionError(newDetails[e.name].split(' ')[0], SubStepDetails.validation.items.indexOf(SubStepDetails.options.indexOf(newDetails[e.name])) !== -1)
      }
      this.setState({details: newDetails}, () => {
        this.props.dispatch(updateDetails(e.name, e.value));
      })
    }
  }

  inputChangeText(e, name){
    let newDetails = Object.assign({}, this.state.details);
    let value = e.target.value;
    newDetails[name] = value;
    this.setState({details: newDetails}, () => {
      if(name === 'team_name' && value === ''){
        console.log("Remove this stuff there man");
        this.props.dispatch(removeTeammatesField());
      }
      if(name === 'email'){
        value = value.toLowerCase();
      }
      this.props.dispatch(updateDetails(name, value));
    })
  }

  teamMatesChange(teammates){
    let newDetails = Object.assign({}, this.state.details);
    let value = teammates;
    newDetails['teammates'] = value;
    this.setState({details: newDetails}, () => {
      this.props.dispatch(updateDetails('teammates', value));
    })
  }

  accountsChange(accounts){
    let newDetails = Object.assign({}, this.state.details);
    let value = accounts;
    newDetails['social_accounts'] = value;
    this.setState({details: newDetails}, () => {
      this.props.dispatch(updateDetails('social_accounts', value));
    })
  }

  isDisabled(){
    return false;
  }

  renderStepInput(){
    let subStep = this.props.currentSubstep;
    let StepDetails = this.props.steps[this.props.currentStep - 1].substeps[subStep - 1];
    if(StepDetails.type === 'free-text'){
      return (
        <div className="form-control-cell">
          <label>{StepDetails.placeholder || ''}</label>
          <input value={this.state.details[StepDetails.field] || ''} onChange={(e) => {
            this.inputChangeText(e, StepDetails.field);
          }} type="text" name={StepDetails.field}/>
        </div>
      );
    }
    if(StepDetails.type === 'name'){
      return (<NameInput value={this.state.details[StepDetails.field] || ''} onChange={(e) => {
        let ev = {target: {value: e}};
        this.inputChangeText(ev, 'name');
      }} />);
    }
    if(StepDetails.type === 'select'){
      return (
        <div className="form-control-cell">
          <label>{StepDetails.placeholder || ''}</label>
          <Select
            clearable={false}
            arrowRenderer={null}
            name="form-field-name"
            searchable={false}
            value={this.state.details[StepDetails.field] || ''}
            onChange={this.handleChange.bind(this)}
            options={StepDetails.options.map((opt) => {return {value: opt, label: opt, name: StepDetails.field}})}
          />
          {this.state.details[StepDetails.field] === 'Other' && (
            <div className="form-control-cell form-control-input-other">
              <label>{StepDetails.placeholder || 'Other'}</label>
              <input placeholder={StepDetails.placeholder || ''} value={this.state.details[StepDetails.field + "_other"] || ''} onChange={(e) => {
                this.inputChangeText(e, (StepDetails.field + "_other"));
              }} type="text" name={StepDetails.field}/>
            </div>
          )}
        </div>
      );
    }
    if(StepDetails.type === 'multiselect'){
      return (
        <div className="form-control-cell">
          <label>{StepDetails.placeholder || ''}</label>
          <Select.Creatable
            closeOnSelect={false}
            disabled={false}
            searchable={false}
            arrowRenderer={null}
            multi
            onChange={this.handleChange.bind(this)}
            options={StepDetails.options.map((opt) => {return {value: opt, label: opt, name: StepDetails.field}})}
            placeholder={this.state.details[StepDetails.field] || ''}
            removeSelected={true}
            simpleValue
            value={this.state.details[StepDetails.field] || []}
          />
        </div>
      );
    }
    if(StepDetails.type === 'emails'){
      return (<Teammates isValid={(data) => {
        this.setState({teammatesValid: data});
      }} teammates={this.state.details.teammates} onChange={this.teamMatesChange.bind(this)} />);
    }
    if(StepDetails.type === 'accounts'){
      return (<Accounts accounts={this.state.details.social_accounts} onChange={this.accountsChange.bind(this)} />);
    }
    return null;
  }

  handleMultiSelect (e) {
    console.log('You\'ve selected:', e);
		this.setState({ multivalue: e });
	}

  validateStep(){
    let subStep = this.props.steps[this.props.currentStep-1].substeps[this.props.currentSubstep-1];
    let currentDetailsData = this.state.details[subStep.field];
    if(subStep.field === "teammates"){
      return !this.state.teammatesValid;
    }
    if(subStep.required && !currentDetailsData){
      return true;
    };
    if(!subStep.validation){
      return false;
    }
    if(subStep.validation.constructor === RegExp){
      console.log(subStep.validation, subStep.validation.test(currentDetailsData));
      return !subStep.validation.test(currentDetailsData);
    }
    if(subStep.validation.constructor === Object){
      if(subStep.validation.type === 'exact'){
        return !(subStep.options.indexOf(currentDetailsData) === subStep.validation.value);
      }
      if(subStep.validation.type === 'block'){
        // this.updateRegistartionError(currentDetailsData.split(' ')[0], subStep.validation.items.indexOf(subStep.options.indexOf(currentDetailsData)) !== -1)
        return subStep.validation.items.indexOf(subStep.options.indexOf(currentDetailsData)) !== -1;
      }
    }
    return false;
  }

  displayErrorElement(location){
    return (
      <span>
        The registration process for {location} has been closed. For more information about further initiatives and adidas team please check <a rel="noopener noreferrer" href="http://careers.adidas-group.com/locations/hubs/zaragoza" target="_blank"> adidas Zaragoza</a> web-page
      </span>
    );
  }

  updateRegistartionError(location, isShown){
    if(isShown){
      this.setState({displayError: this.displayErrorElement(location)});
    }else{
      this.setState({displayError: ''});
    }
  }

  renderNextButton(){
    if((this.props.steps.length === this.props.currentStep) && (this.props.steps[this.props.steps.length - 1].substeps.length === this.props.currentSubstep)){
      return (
        <RaisedButton disable={this.state.details.toc !== 'Yes'} text="Submit" onClick={() => {
          // console.log(this.props.details);
          this.props.dispatch(sendDetails(this.props.details));
        }}/>
      );
    }
    return (
      <RaisedButton text={`Next`} disable={this.validateStep()} onClick={() => {
        this.goNext(true);
      }}/>
    );
  }

  renderTeamName(){
    if(this.props.teamName !== ''){
      return (<div className="my-team-name">Your team: <b>{this.props.teamName}</b></div>);
    }
    return null;
  }

  goNext(skip_next){
    let subStep = this.props.steps[this.props.currentStep-1].substeps[this.props.currentSubstep-1];
    let currentDetailsData = this.state.details[subStep.field];
    switch (subStep.field) {
      case 'team_name':
        if(currentDetailsData){
          console.log("Go with the FLow", currentDetailsData);
          this.props.dispatch(checkTeam(currentDetailsData));
          // this.props.dispatch(applyTeammatesField(true));
        }else{
          this.props.dispatch(nextApplyStep());
        }
        break;
      case 'email':
        this.props.dispatch(checkEmails([currentDetailsData.toLowerCase()]));
        break;
      case 'teammates':
        let emails = [];
        if(this.state.details.teammates && this.state.details.teammates.length){
          emails = this.state.details.teammates.map((mate) => mate.email.toLowerCase());
        }
        this.props.dispatch(checkEmails(emails));
        break;
      default:
        this.props.dispatch(nextApplyStep());
    }
  }

  render(){
    return (
      <div className="modal-full-container">
        <header>
            <div className="header-top">
              <div>
                <div className="left">adidas Hackathons 2018 : Register</div>
                <div className="login-info">
                  <a href="https://dashboard.adidas-hack.com/login" className="link-login">login</a>
                  <span className="link-login-ico"><MdPerson color="#ffffff"/></span>

                  <div className="close-modal" onClick={() => {
                    this.props.dispatch(switchApplyPopup(false));
                  }}>
                    <MdClose size="2em" color={'#ffffff'} />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-header-main">
              <div>
                <h5 className="color-red nospace">#HereToCreate</h5>
                <h2 className="nospace">JOIN THE GAME.</h2>
              </div>
            </div>
        </header>

        <main className="modal-main">
          <Section className="modal-section-register">
            <div className="modal-register-steps">
              {this.props.steps.map((step, key) => {
                return (
                  <RegisterStep key={key} title={step.title} step={key+1} substeps={step.substeps.length} lastStep={this.props.steps.length === (key + 1)} />
                );
              })}
            </div>
            <div className="modal-register-container">
              {this.renderTeamName()}
              <div className="modal-register-content">
                <div className="modal-step-counter">{this.renderCounter()}</div>
                <div className="modal-step-title">
                  {this.renderStepTitle()}
                  <p><small>{this.renderDescription()}</small></p>
                </div>
                <div className="modal-register-form">
                  {this.renderStepInput()}
                </div>
                <div className="modal-step-title">
                  <p><small>{this.state.displayError}</small></p>
                </div>
              </div>

              <div className="modal-next-step">
                {!(this.props.currentStep === 1 && this.props.currentSubstep === 1) && (
                  <RaisedButton text="Previous" onClick={() => {
                    this.props.dispatch(prevApplyStep());
                  }}/>
                )}
                {this.renderNextButton()}
              </div>
              <div className="modal-next-step error">
                {this.props.error && (
                  <p>{this.props.error.error}</p>
                )}
              </div>
            </div>
          </Section>
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  steps: state.apply.steps,
  currentStep: state.apply.currentStep,
  currentSubstep: state.apply.currentSubstep,
  details: state.details.data,
  teamName: state.details.teamName,
  error: state.details.error
});

export default connect(mapStateToProps)(ModalApply);



// WEBPACK FOOTER //
// ./src/components/ModalApply/ModalApply.js